var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",on:{"click":_vm.onButtonClick}},[_vm._v("\n  "+_vm._s(_vm.buttonText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }